import React from 'react'
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from 'library/common/SystemBase';
import { Checkbox } from "@progress/kendo-react-inputs";


interface ISystemCheckBox  {
}

/**
 * Creates an Input with Label  
 * */
export default class SystemCheckBox extends SystemBase<ISystemCheckBox>
{

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <this.WrapperDiv>
                <Checkbox
                    type="checkbox"
                    id={this.props.id || ''}
                    name={this.props.name || ''}
                    value={this.state.value}
                    className=""
                    onChange={this.handleChangeCheckBox}
                    onFocus={this.handleFocus}
                    //defaultValue={this.props.defaultValue}
                    onBlur={this.handleBlur}
                    checked={this.props.value || false}
                />
            </this.WrapperDiv>
        );
    }
}
